function applyTierClass() {
    // Find the tier element on the page
    var tierElement = document.querySelector('span[rivo-x-data][rivo-x-text]');
    
    // Get the text content of the tier element
    var tier = tierElement ? tierElement.textContent.trim() : '';

    // Get the image element inside the logo container
    var logoImage = document.querySelector('.rivo-account-card-content-logo img');

    if (tier && logoImage) {
        // Determine the image source based on the tier
        var newImageSrc = "";

        switch (tier.toLowerCase()) {
            case 'Most valueble player':
                newImageSrc = "//ansh46.com/cdn/shop/files/FC_COMMUNITY_NEW-03_300x.png?v=1724763459";
                break;
            case 'Important player':
                newImageSrc = "//ansh46.com/cdn/shop/files/FC_COMMUNITY_NEW-02_300x.png?v=1724763396";
                break;
            case 'rookie':
                newImageSrc = "//ansh46.com/cdn/shop/files/FC_COMMUNITY_NEW-01_300x.png?v=1724763369";
                break;
            default:
                newImageSrc = "/cdn/shop/files/FC_COMMUNITY_NEW-1.png";
                break;
        }

        // Set the new image source
        logoImage.src = newImageSrc;
        
        console.log("Image source updated to:", newImageSrc);
    } else {
        console.warn("Tier information or logo image is not available yet.");
        setTimeout(applyTierClass, 500);  // Retry after 500ms if not found
    }
}

document.addEventListener('DOMContentLoaded', function () {
    applyTierClass();
});








$(document).ready(function() {
        var designersLink = $('.navigation__link.Designers');
        var tocContainer = $('.navigation__toc-container');
        var containerElement = $('.container.custom');

        designersLink.on('click', function(event) {
          $('.mobile-nav-title').text('Designers');
            event.preventDefault();
            
            // Toggle the display and the transform property
            if (tocContainer.css('display') === 'none') {
                tocContainer.css({
                    display: 'block',
                    transform: 'translateX(0%)'
                });
                containerElement.addClass('hidden'); // Add the hidden class
            } 
        });
    });


const parent = document.querySelector('.rivo-account-content');


const secondItem = parent.children[1];
const lastItem = parent.children[parent.children.length - 1];


parent.insertBefore(lastItem, secondItem);


parent.appendChild(secondItem);

